import { render, staticRenderFns } from "./CompetitionPriceDetails.vue?vue&type=template&id=7facc4c6&scoped=true&"
import script from "./CompetitionPriceDetails.vue?vue&type=script&lang=js&"
export * from "./CompetitionPriceDetails.vue?vue&type=script&lang=js&"
import style0 from "./CompetitionPriceDetails.vue?vue&type=style&index=0&id=7facc4c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7facc4c6",
  null
  
)

export default component.exports